module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column h-100 justify-content-between py-4"
  }, [_c('div', [_c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toggleAddPayment
    }
  }, [_vm._v("Payments")]), _vm._v(" "), _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer",
    attrs: {
      "disabled": _vm.disabled || _vm.accessPermissionFilter(['restricted']) || _vm.isReservationReadOnly && _vm.reservation.status != 5 || _vm.isCancellingReservation
    },
    on: {
      "click": _vm.rebookReservation
    }
  }, [_vm._v("Rebook")]), _vm._v(" "), _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest color-6 text-center font-weight-600 py-3 border-light radius-normal pointer",
    attrs: {
      "disabled": _vm.disabled || _vm.accessPermissionFilter(['restricted']) || _vm.isReservationReadOnly && _vm.reservation.status != 5 && _vm.reservation.status != -5 || _vm.isCancellingReservation
    },
    on: {
      "click": _vm.deleteReservation
    }
  }, [_vm._v("Cancel Booking")]), _vm._v(" "), _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.sendTicket
    }
  }, [_vm._v(_vm._s(_vm.isSendingTicket ? 'Sending Email' : 'Send Email'))]), _vm._v(" "), _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer",
    attrs: {
      "disabled": _vm.disabled || _vm.isReservationReadOnly && _vm.reservation.status != -5
    },
    on: {
      "click": _vm.viewTicket
    }
  }, [_vm._v(_vm._s(_vm.isGeneratingViewTicket ? 'Generating ticket' : 'View Ticket'))])]), _vm._v(" "), _c('div', [(_vm.showInvoiceBtn) ? _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer",
    class: {
      'opacity-50 notAllowed': _vm.unsavedChanges
    },
    attrs: {
      "disabled": _vm.disabled || _vm.isSavingReservation || _vm.getIsCreatingInvoice
    },
    on: {
      "click": _vm.startCreateInvoice
    }
  }, [_vm._v(_vm._s(_vm.getIsCreatingInvoice ? 'Invoicing...' : 'Invoice'))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer",
    attrs: {
      "disabled": _vm.disabled || _vm.isSavingReservation || _vm.isSendingTicketAndPrint
    },
    on: {
      "click": function($event) {
        return _vm.saveReservation({
          printTicket: true,
          closeModal: false
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.isSendingTicketAndPrint ? 'Printing...' : 'Print'))]), _vm._v(" "), _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-color-3 lightest text-center font-weight-600 py-3 border-light radius-normal pointer",
    attrs: {
      "disabled": _vm.disabled || _vm.isSavingReservation || _vm.isSendingTicketAndPrint
    },
    on: {
      "click": function($event) {
        return _vm.saveReservation({
          printTicket: false,
          closeModal: false
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.isSavingReservation ? 'Saving...' : 'Save'))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-24dfe6fb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24dfe6fb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEdit/SideButtons.vue
// module id = 1149
// module chunks = 0